export const demoAccessLayoutMessages = {
  collapseNavigation: 'Collapse navigation',
  expandNavigation: 'Expand navigation',
  skipToContent: 'Skip to content',
  apiUnauthorized: 'Session expired or unauthorized. Sign in again with the admin token.',
  apiForbidden: 'This action requires admin scope. Use the instance admin token or an admin API token.',
  apiRateLimited: 'Too many attempts. Please wait and try again.',
  apiTimeout: 'The request timed out. Try again or check the API origin.',
  apiRequestFailed: 'The request failed. Please try again.',
  demoLoginSubtitle: 'Enter the public preview code to open the Demo Admin UI',
  demoAccessCode: 'Preview access code',
  demoAccessCodePlaceholder: 'Enter the preview access code',
  demoAccessHint:
    'Preview code {code} only unlocks this Admin UI. The Demo API stays publicly readable and is not a security secret.',
  invalidDemoAccessCode: 'Invalid preview access code.',
  showDemoAccessCode: 'Show preview access code',
  hideDemoAccessCode: 'Hide preview access code',
  enterDemo: 'Enter Demo',
  viewVersionChangelog: 'View changelog for Linketry v{version}',
} as const;
